import React from "react";
import { ArrowRightOutlined, MessageFilled } from "@ant-design/icons";

const getInitials = (firstName, lastName, fallback) => {
  const initials = `${firstName?.[0] || ""}${lastName?.[0] || ""}`.trim();
  return (initials || fallback?.[0] || "?").toUpperCase();
};

const ChatToast = ({ extra = {} }) => {
  const chatType =
    extra.chat_type || extra.session_id?.split("_")?.[1] || "partner";
  const isInternal = chatType === "internal";
  const isTagged = extra.notification_type === "tagged";
  const ipId = extra.ip_id || extra.session_id?.split("_")?.[0];
  const senderName =
    `${extra.first_name || ""} ${extra.last_name || ""}`.trim() ||
    extra.username ||
    "Someone";
  const variant = isInternal ? "internal" : "partner";

  return (
    <div className={`chat-toast-card chat-toast-card--${variant}`}>
      <div className="chat-toast-avatar">
        {getInitials(extra.first_name, extra.last_name, extra.username)}
        <span className="chat-toast-avatar-badge">
          <MessageFilled />
        </span>
      </div>
      <div className="chat-toast-body">
        <div className="chat-toast-header">
          <span className="chat-toast-sender">{senderName}</span>
          <span className="chat-toast-time">now</span>
        </div>
        <div className="chat-toast-meta">
          {ipId && <span className="chat-toast-ip">IP {ipId}</span>}
          <span className={`chat-toast-chip chat-toast-chip--${variant}`}>
            {isInternal ? "Internal" : "Partner"}
          </span>
          {isTagged && (
            <span className="chat-toast-chip chat-toast-chip--mention">
              @ Mentioned you
            </span>
          )}
        </div>
        {extra.message && (
          <div className="chat-toast-message">{extra.message}</div>
        )}
        <div className="chat-toast-cta">
          Open chat <ArrowRightOutlined />
        </div>
      </div>
    </div>
  );
};

export default ChatToast;
